import { Modal, ModalVariant } from '@patternfly/react-core'
import * as React from 'react'

import type {
  MedicationRoute,
  MedicationDosageUnit,
} from '@app/domain/patient-medication-history/patient-medication-history.interface'

import { EditableMedicationForm } from './editable-medication-form'

interface Props {
  addMedication: (
    name: string,
    medicationDosageUnitId: string,
    medicationRouteId: string,
  ) => void
  isModalOpen: boolean
  onCancel: () => void
  medicationRoutes: MedicationRoute[]
  medicationDosageUnits: MedicationDosageUnit[]
}

export const AddMedicationModal = function ({
  addMedication,
  isModalOpen,
  onCancel,
  medicationRoutes,
  medicationDosageUnits,
}: Props) {
  return (
    <Modal
      variant={ModalVariant.small}
      title="Add Medication"
      isOpen={isModalOpen}
      onClose={onCancel}
    >
      <EditableMedicationForm
        onSubmitMedication={addMedication}
        medicationRoutes={medicationRoutes}
        medicationDosageUnits={medicationDosageUnits}
        onCancel={onCancel}
      />
    </Modal>
  )
}
